package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.cash_register_configuration.tabs.general

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.thenIf
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.config.borderSetting
import org.hs_soft.runmynesto.domain.config.showContentInOnePage
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.general.ModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.general.PriceLevelHouseButtonEnum
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.operation.get_cash_register_config.GetCashRegister
import org.hs_soft.runmynesto.domain.model.home.user.tabs.user_checkout.user_checkout_model.Children
import org.hs_soft.runmynesto.domain.model.home.user.tabs.user_checkout.user_checkout_model.ChildrenX
import org.hs_soft.runmynesto.domain.model.home.user.tabs.user_checkout.user_checkout_model.ChildrenXX
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsEvent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Text

@Composable
fun GeneralTabCashRegisterConfig(
    event: (OptionsEvent) -> Unit,
    windowSizeMode: WindowSizeModeEnum,
    cashList: List<Children>?,
    selectedOffice: Children?,
    selectedRegion: ChildrenX?,
    selectedBranch: ChildrenXX?,
    cashRegisterConfigData: GetCashRegister?,
) {
    val layoutModifier = Modifier
        .showContentInOnePage()
        .fillMaxWidth()
        .borderSetting()
        .borderRadius(Dimen.semiLargeRadius)
        .padding(Dimen.extraLargePadding)

    if (windowSizeMode == WindowSizeModeEnum.Desktop) {
        Row(modifier = layoutModifier) {
            LeftColumnContent(
                event = event,
                cashList = cashList,
                selectedOffice = selectedOffice,
                selectedRegion = selectedRegion,
                selectedBranch = selectedBranch,
                cashRegisterConfigData = cashRegisterConfigData
            )
            RightColumnContent(
                event = event,
                cashRegisterConfigData = cashRegisterConfigData,
                windowSizeMode=windowSizeMode,
            )
        }
    } else {
        Column(modifier = layoutModifier) {
            LeftColumnContent(
                event = event,
                cashList = cashList,
                selectedOffice = selectedOffice,
                selectedRegion = selectedRegion,
                selectedBranch = selectedBranch,
                cashRegisterConfigData = cashRegisterConfigData
            )
            RightColumnContent(
                event = event,
                cashRegisterConfigData = cashRegisterConfigData,
                windowSizeMode=windowSizeMode,
            )
        }
    }
}

@Composable
fun LeftColumnContent(
    event: (OptionsEvent) -> Unit,
    cashList: List<Children>?,
    selectedOffice: Children?,
    selectedRegion: ChildrenX?,
    selectedBranch: ChildrenXX?,
    cashRegisterConfigData: GetCashRegister?
) {
    Column(modifier = Modifier) {

        DropDownItem(
            modifier = Modifier,
            itemWidth = Dimen.semiLargeEditTextWidth,
            options = cashList ?: listOf(),
            label = Strings.current().office,
            selectedItem = selectedOffice,
            displayText = {
                if (it is Children)
                    it.name ?: "" else ""
            },
            onOptionClick = {
                if (it is Children){
                    event(OptionsEvent.OnSelectOffice(it))
                }

            }
        )

        DropDownItem(
            modifier = Modifier
                .margin(top = Dimen.mediumPadding),
            itemWidth = Dimen.semiLargeEditTextWidth,
            options = selectedOffice?.children ?: listOf(),
            label = Strings.current().region,
            selectedItem = selectedRegion,
            displayText = {
                if (it is ChildrenX)
                    it.name ?: "" else ""
            },
            onOptionClick = {
                if (it is ChildrenX){
                    event(OptionsEvent.OnSelectRegion(it))
                }


            }
        )

        DropDownItem(
            modifier = Modifier
                .margin(top = Dimen.mediumPadding),
            itemWidth = Dimen.semiLargeEditTextWidth,
            options = selectedRegion?.children ?: listOf(),
            label = Strings.current().branch,
            selectedItem = selectedBranch,
            displayText = {
                if (it is ChildrenXX)
                    it.name ?: "" else ""
            },
            onOptionClick = {
                if(it is ChildrenXX){
                    event(OptionsEvent.OnSelectShop(it))
                }

            }
        )

        CustomEditText(
            marginTop = Dimen.mediumPadding,
            value = cashRegisterConfigData?.name ?: "",
            isOutlinedEditText = true,
            marginBottom = 0.px,
            isRequired = false,
            label = Strings.current().cashierName,
            onFocusOut = {
                event(
                    OptionsEvent.UpdateCashRegisterConfigData(
                        title = ApiUtils.Field.name,
                        value = it,
                        valueIsInParameters = false,
                        configsList = emptyList()
                    )
                )
            },
            onFocusIn = {},
            onInputChange = {it, validation ->

            },
        )
    }
}

@Composable
fun RightColumnContent(
    event: (OptionsEvent) -> Unit,
    cashRegisterConfigData: GetCashRegister?,
    windowSizeMode: WindowSizeModeEnum,
) {
    Column(modifier = Modifier
        .thenIf(
            windowSizeMode== WindowSizeModeEnum.Desktop,
            Modifier.margin(left = Dimen.largePadding)
        )
    )
    {
        DropDownItem(
            modifier = Modifier,
            itemWidth = Dimen.semiLargeEditTextWidth,
            options = PriceLevelHouseButtonEnum.entries,
            label = Strings.current().priceLevels,
            selectedItem = PriceLevelHouseButtonEnum.entries.find {
                it.value == cashRegisterConfigData?.priceLevelOut
            },
            displayText = {
                if (it is PriceLevelHouseButtonEnum)
                    it.toString() else ""
            },
            onOptionClick = {
                if (it is PriceLevelHouseButtonEnum){
                    event(
                        OptionsEvent.UpdateCashRegisterConfigData(
                            title = ApiUtils.Field.priceLevelOut,
                            value = it.value ?: 0,
                            valueIsInParameters = false,
                            configsList = emptyList()
                        )
                    )
                }


            },
        )

        DropDownItem(
            modifier = Modifier
                .margin(top = Dimen.mediumPadding),
            itemWidth = Dimen.semiLargeEditTextWidth,
            options = PriceLevelHouseButtonEnum.entries,
            label = Strings.current().priceLevelInHouseButton,
            selectedItem = PriceLevelHouseButtonEnum.entries.find {
                it.value == cashRegisterConfigData?.priceLevelIn
            },
            displayText = {
                if (it is PriceLevelHouseButtonEnum)
                     it.title else ""
            },
            onOptionClick = {
                if (it is PriceLevelHouseButtonEnum){
                    event(
                        OptionsEvent.UpdateCashRegisterConfigData(
                            title = ApiUtils.Field.priceLevelIn,
                            value = it.value ?: 0,
                            valueIsInParameters = false,
                            configsList = emptyList()
                        )
                    )
                }


            }
        )

        DropDownItem(
            modifier = Modifier
                .margin(top = Dimen.mediumPadding),
            itemWidth = Dimen.semiLargeEditTextWidth,
            options = ModeEnum.entries,
            label = Strings.current().mode,
            selectedItem = ModeEnum.entries.find {
                it.value == cashRegisterConfigData?.mode
            },
            displayText = {
                if (it is ModeEnum)
                    it.title  else ""
            },
            onOptionClick = {
                if(it is ModeEnum){
                    event(
                        OptionsEvent.UpdateCashRegisterConfigData(
                            title = ApiUtils.Field.mode,
                            value = it.value,
                            valueIsInParameters = false,
                            configsList = emptyList()
                        )
                    )
                }

            }
        )
    }
}